import { Order } from '@europrocurement/l2d-domain/reducers/formalites/slices/orderSlice';
import { DossierOpenSearch } from '@europrocurement/l2d-domain';
import { createContext, useContext } from 'react';

interface SelectedOrderContextType {
    order: Order;
    setOrder: React.Dispatch<React.SetStateAction<Order>>;
    dossiers: Array<DossierOpenSearch>;
    setDossiers: React.Dispatch<React.SetStateAction<DossierOpenSearch[]>>;
    refreshOrder: () => void;
    dossiersLoading: boolean;
    dossiersError: string | null;
    isUpdatingPriority: boolean;
    updateOrderPriority: (newCritical: boolean) => Promise<void>;
}

const defaultContext: SelectedOrderContextType = {
    order: { dossiers: [], typeFacturation: 'SIMPLIFIEE' },
    setOrder: () => {},
    dossiers: [],
    setDossiers: () => {},
    refreshOrder: () => {},
    dossiersLoading: false,
    dossiersError: null,
    isUpdatingPriority: false,
    updateOrderPriority: async () => {},
};

const SelectedOrderContext = createContext<SelectedOrderContextType>(defaultContext);

export const useSelectedOrderContext = () => {
    const context = useContext(SelectedOrderContext);
    if (!context) {
        throw new Error('useSelectedOrderContext must be used within a SelectedOrderProvider');
    }
    return context;
};

export default SelectedOrderContext;
